import React from "react";
import { Button } from "@headlessui/react";
import { Navigate } from "ellipse/navigate/Navigate";

export interface IndexProductsCardProps {

	index: number;
	name: string;
	headline: string;
	description: string;
	image: string;
	url?: string;

}

const IndexProductsCard: React.FC<IndexProductsCardProps> = (props: IndexProductsCardProps) => {

	const goToURL = () => {
		if (props.url) {
			Navigate.navigateTo(props.url);
		}
	};

	return (
		<div id={`indexproductscard-root-${props.index}`} className="indexproductscard-root">
			<h1 className="indexproductscard-main-text font-bold pb-2" id={`indexproductscard-main-text-${props.index}`}>
				{props.name} {props.url === undefined ? " (Coming Soon)" : ""}
			</h1>
			<div id={`indexproductscard-container-${props.index}`} className="indexproductscard-container flex p-4 flex-col items-start rounded-md">
				<div id={`indexproductscard-content-${props.index}`} className="indexproductscard-content flex flex-col lg:flex-row items-start">
					<img src={`images/${props.image}`} alt="AI-assisted conversion for Uizard layouts" id={`indexproductscard-image-${props.index}`} className="indexproductscard-image rounded-lg border-4 w-64" />
					<div id={`indexproductscard-text-container-${props.index}`} className="indexproductscard-text-container pl-4">
						<p id={`indexproductscard-headline-text-${props.index}`} className="indexproductscard-headline-text pb-2 pt-4 lg:pt-0">
							{props.headline}
						</p>
						<p id={`indexproductscard-secondary-text-${props.index}`} className="indexproductscard-secondary-text">
							{props.description}
						</p>
					</div>
				</div>
				{props.url !== undefined && (
					<Button id={`indexproductscard-visit-${props.index}`} data-testid={`indexproductscard-visit-${props.index}`} className="indexproductscard-visit rounded-md px-4 py-2 mt-4" onClick={goToURL}>
						Visit {props.name}
					</Button>
				)}
			</div>
		</div>
	);

};

export default IndexProductsCard;